import HttpClient from "@api/clients/httpClient";
import AuthenticationModel from "@api/models/AuthenticationModel";
import { Filter } from "@api/models/HttpClientModels";
import RefreshTokenRequestModel from "@api/models/RefreshTokenRequestModel";

const config = { endpoint: "token", };

export default class AuthenticationService {
    httpClient: HttpClient;

    constructor() {
        this.httpClient = new HttpClient(config.endpoint, new Filter());
    }

    loginAsync = async (userName: string, password: string) => {
        const authenticationModel: AuthenticationModel = {
            userName: userName,
            password: password,
            grant_type: "password"
        };

        return await this.httpClient.getTokenAsync(authenticationModel);
    };

    refreshTokenAsync = async (refreshToken: string) => {
        const model: RefreshTokenRequestModel = {
            grant_type: "refresh_token",
            refresh_token: refreshToken,
        };

        return await this.httpClient.getRefreshTokenAsync(model);
    };

}